import { useMutation } from '@tanstack/react-query';
import type { ResendPensioenbijEventsArgs } from '../../../Domain/Tools/Services';
import { toolsServices } from '../../../Domain/Tools/Services';

const mutationFn = (data: ResendPensioenbijEventsArgs) => {
  return toolsServices.resendPensioenbijEvents(data);
};

export const useResendPensioenbijMutation = () => {
  return useMutation<unknown, unknown, ResendPensioenbijEventsArgs>(mutationFn);
};
